module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal__overlay",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "modal__container"
  }, [_c('div', {
    staticClass: "modal__close",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span'), _c('span')]), _c('div', {
    staticClass: "modal__content"
  }, [_c('h2', [_vm._v("Thank you!")]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.modalContent === 1),
      expression: "$store.state.modalContent === 1"
    }],
    staticClass: "modal__text"
  }, [_c('p', [_vm._v("We will get back to you as soon as possible! ")]), _c('p', [_vm._v("Looking forward to seeing you in the office!")])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.modalContent === 2),
      expression: "$store.state.modalContent === 2"
    }],
    staticClass: "modal__text"
  }, [_c('p', [_vm._v("We appreciate your feedback!")])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.modalContent === 3),
      expression: "$store.state.modalContent === 3"
    }],
    staticClass: "modal__text"
  }, [_c('p', [_vm._v("We appreciate the referral!      ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f55d1b6c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/modal/modal.pug
// module id = 618
// module chunks = 1